import HelloSign from 'hellosign-embedded';

export default function getHelloSignClient(clientId) {
  return new HelloSign({
    clientId: clientId,
  });
}
